import { platform } from '../platform';
export default platform(
  () => import('./web/TestPage'),
  () => import('./mobile/TestPage')
);
